import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Driver from '../components/home/drivers/Driver';
import Vehicle from '../components/home/vehicles/Vehicle';
import About from '../components/home/about/About';
import OnboardHome from '../containers/onboard/OnboardHome';

const OnboardRouting = () => (
  <Routes>
    <Route path="/" element={<OnboardHome />} />
    <Route path={`/drivers/:id`} element={<Driver />} />
    <Route path={`/vehicles/:id`} element={<Vehicle />} />
    <Route path={`/about`} element={<About />} />
    <Route path="*" element={<Navigate to={`/`} replace />} />
  </Routes>
);

export default OnboardRouting;
